import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BottomNav } from './components/BottomNav';
import { SplashScreen } from './pages/SplashScreen';
import { HomePage } from './pages/HomePage';
import { ResultsPage } from './pages/ResultsPage';
import { PathFinderPage } from './pages/PathFinderPage';
import { SegmentDetailsPage } from './pages/SegmentDetailsPage';
import { PassengerInfoPage } from './pages/PassengerInfoPage';
import { PaymentPage } from './pages/PaymentPage';
import { ETicketPage } from './pages/ETicketPage';
import { MyTripsPage } from './pages/MyTripsPage';
import { HelpPage } from './pages/HelpPage';
export function App() {
  return <Router data-id="element-0">
      <div className="app-container" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<SplashScreen data-id="element-4" />} data-id="element-3" />
          <Route path="/home" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/results" element={<ResultsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/path-finder" element={<PathFinderPage data-id="element-10" />} data-id="element-9" />
          <Route path="/segment-details" element={<SegmentDetailsPage data-id="element-12" />} data-id="element-11" />
          <Route path="/passenger-info" element={<PassengerInfoPage data-id="element-14" />} data-id="element-13" />
          <Route path="/payment" element={<PaymentPage data-id="element-16" />} data-id="element-15" />
          <Route path="/eticket" element={<ETicketPage data-id="element-18" />} data-id="element-17" />
          <Route path="/my-trips" element={<MyTripsPage data-id="element-20" />} data-id="element-19" />
          <Route path="/help" element={<HelpPage data-id="element-22" />} data-id="element-21" />
        </Routes>
        <BottomNav data-id="element-23" />
      </div>
    </Router>;
}